export default "__VITE_ASSET__Celz9LMq__"